<template>
  <div class="company">
    <div class="title">
      {{resDatas.title}}
    </div>
    <div class="company-main">
      <ul>
        <li v-for="iten in resDatas.companyDets">
          <span>{{iten.label}}</span><span><em v-if="iten.img"><img :src="require('../assets/images/'+iten.img+'')" alt=""></br> </em> <a :href="iten.url" target="_blank">{{iten.url}}</a> {{iten.content}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        resDatas:''
      }
    },
    props: {
        resData: {
        }
    },
    watch: {
        resData(newData){
          this.resDatas=newData;
        }
    },
    mounted() {
      this.$parent.getlan();
    }
  }
</script>

<style scoped>
  .company{
    width: 50%;
    margin: auto;
  }
  .company .title{
    font-size: 22px;
    padding: 3%;
    font-weight: 600;
    text-align: center;
  }
  .company-main{
    margin-top: 3%;
  }
  .company-main li{
    display: block;
    padding: 2%;
    font-size: 0;
    box-sizing: border-box;
  }
  .company-main li:nth-of-type(2n+1){
    background-color: #EBEBEB;
  }
  .company-main li span{
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    vertical-align: middle;
    word-break: break-all;
    box-sizing: border-box;
  }
  .company-main li span:nth-of-type(1){
    width: 34%;
    text-align: center;
  }
  .company-main li span:nth-of-type(2){
    width: 66%;
    color: #818181;
    padding: 0 1%;
  }
  .company-main li span img{
    width: 35%;
    vertical-align: middle;
  }
  @media screen and (max-width: 1000px){
    .company{
      width: 90%;
      margin: auto;
    }
    .company-main li{
      padding: 1.5% 0;
    }
    .company-main li span{
      font-size: 18px;
    }
    .company-main li span:nth-of-type(1){
      padding: 0 1.5%;
    }
    .company-main li span img{
      width: 50%;
      vertical-align: middle;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/company.vue